import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { LayoutProps } from 'Lib/LayoutProps.type';

import { NotificationsContext } from 'Components/Notifications';
import { NotificationUpdate } from 'Components/UI_Library/Notification';
import Prism from 'Components/UI_Library/Prism/Prism';
import * as alertActions from '../../Redux/Actions/alertActions';
import Header from '../Header';
import './MainLayout.css';
import Menu from '../Menu';
import NoCompanySelectedMenu from 'Components/Menu/Fenix/NoCompanySelectedMenu/NoCompanySelectedMenu';
import { isOktaInternalAuthToken } from 'Lib/Utils/authToken';

const MainLayout = (props: LayoutProps) => {
    const dispatch = useDispatch();
    const notifications = useContext(NotificationsContext);
    const routesToShowNoCompanySelectedMenu = ['/home'];

    // add isOktaInternal check for extra safety - no company view should not be applicable for non-Fenix users
    const isOnNoCompanySelectedView = () =>
        isOktaInternalAuthToken() && routesToShowNoCompanySelectedMenu.includes(window.location.pathname);

    useEffect(() => {
        dispatch(alertActions.getList());
    }, []);

    return (
        <div id="wrapper">
            <Prism featureName="UrgentMessage" fallback={<></>}>
                <div className="urgent-message" />
            </Prism>
            <div id="mask" />
            <div id="container">
                {isOnNoCompanySelectedView() ? <NoCompanySelectedMenu /> : <Menu focus={!!props.focus} />}
                <div id="main" className={`container-fluid ${props.focus ? 'focus' : ''}`}>
                    <Header title={props.title} />
                    <Prism featureName="Subscriptions" fallback={<></>}>
                        {notifications.updates.length > 0 &&
                            // subscription notifications not relevant when on no company view
                            !isOnNoCompanySelectedView() && (
                                <NotificationUpdate
                                    notification={notifications.updates[0]}
                                    onClose={() => notifications.removeUpdate(notifications.updates[0])}
                                />
                            )}
                    </Prism>
                    <div id="content" className={`${props.fullWidth ? 'container-fullwidth' : ''}`}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainLayout;
